// extracted by mini-css-extract-plugin
export default {"root":"_34hpiuv7","heading":"NtDe4YsW","list":"B-AQXapM"};